import { useSystemAgent } from '@frontend/features/agents/hooks';

/** The Steward's stable agent_id (matches the seed + the published directory agent). */
export const STEWARD_AGENT_ID = 'stickyboard_steward';

/**
 * Resolves the Steward's per-instance UUID via the shared system-agent ensure path, which
 * installs the Steward as a system agent on demand if it isn't already present. Thin wrapper
 * over {@link useSystemAgent} so Steward consumers keep the same `{ agentUuid, ready }` shape.
 *
 * Resolving through the ensure endpoint (rather than scanning the specialized-agents list)
 * fixes the empty-board chicken-and-egg: curate only fires when the board changes, so a fresh
 * board would otherwise never install the Steward and its interactive features would stay dark.
 */
export function useStewardAgent() {
  return useSystemAgent(STEWARD_AGENT_ID);
}
